<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset">
      <template #start>
        <el-form-item class="startBtn">
          <el-button type="primary" @click="addItem" icon="el-icon-plus">添加</el-button>
        </el-form-item>
      </template>
    </SearchField>

    <Table ref="table" :tableData="tableData" :cols="cols" :page="page" :limit="limit" :total="total" :showIndex="true" :btns="btns"
      @onSelectionChange="onSelectionChange" @onCurrentChange="onCurrentChange" @onSizeChange="onSizeChange" />

    <FormDialog ref="dialog" :title="title" :width="'548px'" :labelWidth="'110px'" :form="mform" :rules="mrules"
      :formCtrl="mformCtrl" :viewMode="false" @onModalSubmit="onModalSubmit"></FormDialog>
  </div>
</template>

<script>
import tableMixin from "../../mixin/table";

export default {
  name: "CustomerCarrier",
  mixins: [tableMixin],
  data() {
    return {
      baseUrl: 'pcustom',
      breadcrumb: [
        { name: "客户管理" },
        { name: "承运人管理" },
      ],
      formInline: {},
      formCtrl: [
        {
          label: "公司名称",
          keyName: "company",
          placeholder: "请填写公司名称",
          type: "text",
        },
      ],
      title: '客户添加',
      mform: {},
      mrules: {
        pname: [
          {
            required: true,
            message: '请填写公司名称',
            trigger: 'blur',
          }
        ],
        company: [
          {
            required: true,
            message: '请填写承运联系人',
            trigger: 'blur',
          }
        ],
        phone: [
          {
            required: true,
            validator: this.checkPhone,
            trigger: 'blur',
          },
        ],
        address: [
          {
            required: true,
            message: '请填写地址',
            trigger: 'blur',
          }
        ],
      },
      mformCtrl: [
        {
          label: "公司名称",
          keyName: "company",
          err: "请填写公司名称",
          type: "text",
        },
        {
          label: "承运联系人",
          keyName: "pname",
          err: "请填写承运联系人",
          type: "text",
        },
        {
          label: "联系方式",
          keyName: "phone",
          err: "请填写联系方式",
          type: "text",
          //className:'de-adsu',
        },
        {
          label: "地址",
          keyName: "address",
          err: "请填写地址",
          type: "text",
        },
      ],
      cols: [
        { prop: "company", label: "公司名称", minwidth: 200 },
        { prop: "address", label: "公司地址", minwidth: 200 },
        { prop: "pname", label: "承运联系人" },
        { prop: "phone", label: "联系方式", minwidth: 120 },
        { prop: "carcount", label: "车辆总数", minwidth: 100 },
      ],
      btns: [
        // {
        //   ...this.editBtn,
        //   cb: ({ id }) => {
        //     this.$router.push(
        //       `/customer/carrierdetail?id=${id}&mode=edit`
        //     );
        //   },
        // },
        {
          ...this.editBtn,
          cb: ({ id }) => {
            // this.$router.push(`/vehicle/expatriatedetail?mode=edit&id=${id}`);
            // console.log(id);
            this.title = "客户编辑";
            this.getData(id);
          },
        },
        {
          ...this.delBtn,
          cb: ({ id }) => {
            this.delete(id)
          },
        },
      ],
    };
  },
  methods: {
    paramsPackage(params, object) {
      for (const key in object) {
        if (Object.hasOwnProperty.call(object, key)) {
          // console.log(typeof object[key])
          const value = object[key]
          params[key] = value;
        }
      }

      const opt = params.id ? 'update' : 'create'

      params['headers'] = {
        'X-Method': opt,
        'X-Module': 'carrier',
      }
    },

    delParamsPackage(params) {
      params['headers'] = {
        'X-Method': 'delete',
        'X-Module': 'carrier',
      }

      // console.log('params', { ...params })
    },

    addItem() {
      this.title = '客户添加'
      this.mform = {
        pname: '',
        company: '',
        phone: '',
        address: '',
      };
      this.showDialog();
    },
    getData(id) {
      this.loading = true;
      let url = `${this.baseUrl}/item`;
      const params = {
        userid: this.user.id,
        id,
      };
      this.mform['id'] = id
      this.post(
        url,
        params,
        (res) => {
          const { msg, data } = res;
          if (msg === "success" && data) {
            // console.log(data);
            this.mformCtrl.map((v) => {
              const key = v.keyName;
              this.mform[key] = data[key];
              this.showDialog();
            });
          } else {
            this.$message({
              type: "error",
              message: "加载失败，请稍后再试！",
            });
          }
          this.loading = false;
        },
        (err) => {
          console.log(err);
          this.$message({
            type: "error",
            message: "获取数据失败，请稍后重试！",
          });
        }
      );
    },
    setOptions({ data }) {
      this.mformCtrl.map(v => {
        if (v.keyName == 'pcusid') {
          v.options = data.map(val => {
            return {
              label: val.pname,
              value: val.id,
            }
          })
        }
      })
    },
  }
};
</script>
<style scoped>
.fillet {
  height: auto;
  /* overflow: hidden; */
  margin: 0 auto;
  padding: 20px 0px 10px;
  border-radius: 5px;
  background: #fff;
  box-shadow: 0px 0px 10px rgb(0 0 0 / 3%);
}

.retrieval {
  height: auto;
  /* overflow: hidden; */
  margin: 0px 20px;
  font-size: 14px;
  color: #606266;
}
</style>